if (!customElements.get('dd-nutrition-tabs')) {
  customElements.define('dd-nutrition-tabs', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), { signal: this.abort.signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.select(next); this.tabs[next].focus(); }
        }, { signal: this.abort.signal });
      });
      this.select(0);
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
